import { OfferPaywallsState } from './types';

const initialState: OfferPaywallsState = {
  offerPaywalls: [],
  expiresAt: {
    boost_99_1_static: 0,
    superlike_1899_15_static: 0,
  },
};

export default initialState;
